import { combineReducers } from 'redux';
import { localizeReducer } from 'react-localize-redux';
import auth from './auth'
import user from './user'


const rootReducer = combineReducers({
  localize: localizeReducer,
  auth,
  user
});
export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js